import { Tooltip } from 'flowbite-react';
import { BiSolidMessageDots } from 'react-icons/bi';
import { ApplicationStatus } from 'types';

interface CurrentRoundProgressProps {
	currentRoundNumber: number;
	totalRounds: number;
	showStatus?: string;
	handleOpenRoundFeedbackHistory?: (() => void) | null;
}

const CurrentRoundProgress = ({
	currentRoundNumber,
	totalRounds,
	showStatus,
	handleOpenRoundFeedbackHistory,
}: CurrentRoundProgressProps) => {
	return (
		<div className="flex flex-col gap-2">
			<div className="flex items-center flex-wrap gap-2">
				<div
					className={`w-fit ${
						showStatus === ApplicationStatus.OFFER_REVOKED ? 'bg-red-200' : 'bg-[#EDEBFE]'
					} px-[10px] py-[2px] rounded-[6px]`}
				>
					<p
						className={`${
							showStatus === ApplicationStatus.OFFER_REVOKED ? 'text-red-600' : 'text-[#5521B5]'
						} font-inter text-[12px] font-[500] leading-[18px]`}
					>
						{showStatus ?? `Round ${currentRoundNumber < totalRounds ? currentRoundNumber : totalRounds}`}
					</p>
				</div>

				{handleOpenRoundFeedbackHistory ? (
					<Tooltip
						content={<p className="text-white">Feedback</p>}
						trigger="hover"
						placement="bottom"
						arrow={false}
						className="mb-0 flex !rounded-[5px] dark:bg-[#1F2A37] dark:text-[#8b8e94] sm:right-0 w-fit sm:!max-w-[255px]"
					>
						<button className="flex" onClick={handleOpenRoundFeedbackHistory}>
							<BiSolidMessageDots className="fill-[#FDAC42] w-[20px] h-[20px]" />
						</button>
					</Tooltip>
				) : null}
			</div>
			<div className="flex flex-wrap items-center gap-[8px]">
				{new Array(totalRounds).fill(1).map((round, i) => {
					return (
						<div
							key={i}
							className={`${
								currentRoundNumber === i + 1
									? 'bg-[#FFCC00]'
									: currentRoundNumber < i + 1
									  ? 'bg-[#C7C9D9]'
									  : 'bg-[#06C270]'
							} w-[28px] h-[8px] rounded-[8px]`}
						></div>
					);
				})}
			</div>
		</div>
	);
};

export default CurrentRoundProgress;
